import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from "../../components/ui/command";
import styled from "styled-components";
import { TooltipProps } from "recharts";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashBoardActions } from "../../store/ducks/dashboard";
import { AppActions } from "../../store/ducks/app";

const SearchUsers: React.FC<TooltipProps<number, string>> = ({ payload }) => {
	const [users, set_users] = useState([]);
	const [quant_users, set_quant_users] = useState([]);

	const [users_protocols, set_users_protocols]: any = useState([]);

	const dispatch = useDispatch();

	const pacientes = useSelector((state: any) => state.dashboard.pacientes);

	useEffect(() => {
		if (payload) {
			if (payload[0]) {
				if (payload[0]?.payload?.usuarios) {
					set_users(payload[0]?.payload?.usuarios);
					set_quant_users(payload[0]?.payload?.usuarios.length);
				}
				if (payload[0]?.payload?.payload?.usuarios) {
					set_users(payload[0].payload.payload.usuarios);
					set_quant_users(payload[0]?.payload?.usuarios.length);
				}
				if (payload[0].payload.alto_risco_users_2) {
					set_users_protocols([
						{
							legenda: "alto_risco_1",
							users: payload[0].payload.alto_risco_users_1,
							fill: "#E57E00",
						},
						{
							legenda: "alto_risco_2",
							users: payload[0].payload.alto_risco_users_2,
							fill: "#D12600",
						},
						{
							legenda: "medio_risco",
							users: payload[0].payload.medio_risco_users,
							fill: "#FFC530",
						},
						{
							legenda: "baixo_risco",
							users: payload[0].payload.baixo_risco_users,
							fill: "#80F279",
						},
					]);
					set_quant_users(
						payload[0].payload.alto_risco_users_1?.length +
							payload[0].payload.alto_risco_users_2?.length +
							payload[0].payload.medio_risco_users?.length +
							payload[0].payload.baixo_risco_users?.length
					);
				}
			}
		}
	}, [payload]);

	const [selected_patient, set_selected_patient]: any = useState();
	const getPatientCarrossel = (paciente: any) => {
		const filtros_paginacao = {
			inicio: 0,
			fim: 1,
			filtros: [
				{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
				{ tipo: "USUARIO_NIVEL", valor: [3] },
				{ tipo: "ID_USUARIO", valor: [paciente] },
			],
		};

		dispatch(DashBoardActions.set_filtros_pacintes_request(filtros_paginacao));
		dispatch(DashBoardActions.paciente_request());
		set_selected_patient(paciente);
	};

	useEffect(() => {
		if (selected_patient) {
			dispatch(AppActions.set_open_paciente(pacientes[0]));
			dispatch(DashBoardActions.set_current_page("perfil_paciente"));
		}
	}, [pacientes]);

	return (
		<Command
			className="rounded-lg border shadow-md bg-white md:min-w-[250px]"
			style={{ display: "flex", flexDirection: "row", pointerEvents: "auto" }}
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			<div
				style={{
					backgroundColor: payload ? payload[0]?.payload?.fill : "",
					width: "0.5rem",
				}}
			></div>
			<div style={{ width: "100%", height: "280px" }}>
				<CommandInput placeholder="Pesquisar" />
				<CommandList style={{ maxHeight: "245px", overflowY: "auto" }}>
					<CommandEmpty>No results found.</CommandEmpty>

					<CommandGroup heading={quant_users + " colaboradores"}>
						{users.map((user: any, index) => (
							<CommandItem style={{ cursor: "pointer" }} key={index}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										width: "100%",
										alignItems: "start",
										gap: 5,
									}}
									onClick={() => getPatientCarrossel(user.user)}
								>
									<Name>{user?.user_nome}</Name>
									<ID>ID: {user?.user}</ID>
								</div>
								<svg
									width="1"
									height="5"
									viewBox="0 0 8 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0.636719 1.1875L5.42187 6L0.636719 10.8125L1.67578 11.8242L7.5 6L1.67578 0.175781L0.636719 1.1875Z"
										fill="#797D8D"
									/>
								</svg>
							</CommandItem>
						))}

						{users_protocols?.map((item: any, index: number) =>
							item?.users?.map((user: any, index: number) => (
								<CommandItem key={index}>
									<div
										style={{
											display: "flex",
											flexDirection: "row",
											width: "100%",

											alignItems: "start",
											gap: 5,
										}}
										onClick={() => getPatientCarrossel(user?.user)}
									>
										<div
											style={{
												backgroundColor: item.fill,
												width: "0.3rem",
												height: "1.8rem",
												borderTopLeftRadius: "5px",
												borderBottomLeftRadius: "5px",
											}}
										></div>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												gap: 5,
											}}
										>
											<Name>{user?.user_nome}</Name>
											<ID>ID: {user?.user}</ID>
										</div>
									</div>
									<svg
										width="1"
										height="5"
										viewBox="0 0 8 12"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M0.636719 1.1875L5.42187 6L0.636719 10.8125L1.67578 11.8242L7.5 6L1.67578 0.175781L0.636719 1.1875Z"
											fill="#797D8D"
										/>
									</svg>
								</CommandItem>
							))
						)}
					</CommandGroup>
				</CommandList>
			</div>
		</Command>
	);
};

const Name = styled.span`
	font-family: "NotoSans-Regular";
	font-weight: 400;
	font-size: 0.8rem;
	line-height: 100%;
	letter-spacing: 0%;
	vertical-align: middle;
	color: #63677a;
`;

const ID = styled.span`
	font-family: "NotoSans-Regular";
	font-weight: 400;
	font-size: 0.8rem;
	line-height: 100%;
	letter-spacing: 0%;
	vertical-align: middle;
	color: #9497a4;
`;

export default SearchUsers;
